import React, { useState } from 'react';
import ErrorBoundary from '../../../components/ErrorBoundary';
import Table from 'react-bootstrap/Table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEdit, faPlus, faTimes, faSave, faCheck, faXmark, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import './style.css';
import { PermissionGate } from '../../../contexts/PermissionGate';


interface Cedente {
  id: number;
  nome: string;
  cnpj: string;
  ativo: boolean;
  id_header_cnab: string;
  id_cnab: string;
  modelo_termo: number;
}

interface Originador {
  razao_social: string;
  nome_fantasia: string;
  cnpj: string;
  ativo: boolean;
  cedentes: Cedente[];
}

const CadastroOriginador = () => {
  const [modais, setModais] = useState({
    edicao: false,
    cedentes: false,
    adicionarCedente: false,
    novoOriginador: false,
    edicaoCedente: false,
    confirmacaoSaida: false
  });

  const [dadosModais, setDadosModais] = useState({
    originadorParaEdicao: null as Originador | null,
    originadorCedentes: null as Originador | null,
    novoCedente: {
      cedente_id: 0,
      id_header_cnab: '',
      id_cnab: '',
      modelo_termo: 1,
      ativo: true
    },
    dadosEdicao: {
      razao_social: '',
      nome_fantasia: '',
      cnpj: '',
      ativo: true
    },
    novoOriginador: {
      razao_social: '',
      nome_fantasia: '',
      cnpj: '',
      ativo: true
    },
    cedentesNovoOriginador: [] as Array<{
      cedente_id: number;
    }>,
    cedenteParaEdicao: null as Cedente | null,
    dadosEdicaoCedente: {
      nome: '',
      cnpj: '',
      id_header_cnab: '',
      id_cnab: '',
      modelo_termo: 1,
      ativo: true
    }
  });

  const [validacaoErro, setValidacaoErro] = useState({
    originador: {
      razao_social: false,
      nome_fantasia: false,
      cnpj: false
    },
    cedentes: [] as Array<{
      cedente_id: boolean;
    }>,
    tentouSalvar: false // Flag para saber se já tentou salvar
  });

  const [alteracoesPendentes, setAlteracoesPendentes] = useState(false);
  const [modalParaFechar, setModalParaFechar] = useState<keyof typeof modais | null>(null);

  const isAdmin = localStorage.getItem('is_admin') === 'true';

  const cedentesDisponiveis = [
    { id: 1, nome: 'Cartos Sociedade de Crédito Direto S.A.', cnpj: '11.111.111/1111-11' },
    { id: 2, nome: 'Viva Crédito S.A.', cnpj: '22.222.222/2222-22' },
    { id: 3, nome: 'Crédito Direto S.A.', cnpj: '33.333.333/3333-33' },
    { id: 4, nome: 'Banco XYZ S.A.', cnpj: '44.444.444/4444-44' },
    { id: 5, nome: 'Financeira ABC S.A.', cnpj: '55.555.555/5555-55' }
  ];

  const mockData: Originador[] = [
    {
      razao_social: 'Cartos Sociedade de Crédito Direto S.A.',
      nome_fantasia: 'Cartos',
      cnpj: '59929098000109',
      ativo: true,
      cedentes: [
        {
          id: 1,
          nome: 'Cartos Sociedade de Crédito Direto S.A.',
          cnpj: '11.111.111/1111-11',
          ativo: true,
          id_header_cnab: '1234567890',
          id_cnab: '1234567890',
          modelo_termo: 1
        },
        {
          id: 2,
          nome: 'Viva Crédito S.A.',
          cnpj: '22.222.222/2222-22',
          ativo: false,
          id_header_cnab: '1234567890',
          id_cnab: '1234567890',
          modelo_termo: 1
        }
      ]
    },
    {
      razao_social: 'Viva Crédito S.A.',
      nome_fantasia: 'Viva Crédito',
      cnpj: '59929098000109',
      ativo: true,
      cedentes: [
        {
          id: 1,
          nome: 'Crédito Direto S.A.',
          cnpj: '59929098000109',
          ativo: true,
          id_header_cnab: '1234567890',
          id_cnab: '1234567890',
          modelo_termo: 1
        }
      ]
    },
    {
      razao_social: 'Crédito Direto S.A.',
      nome_fantasia: 'Crédito Direto',
      cnpj: '59929098000109',
      ativo: true,
      cedentes: [
        {
          id: 1,
          nome: 'Cartos Sociedade de Crédito Direto S.A.',
          cnpj: '59929098000109',
          ativo: true,
          id_header_cnab: '1234567890',
          id_cnab: '1234567890',
          modelo_termo: 1
        }
      ]
    }
  ];

  const abrirModal = (tipoModal: keyof typeof modais, dados?: any) => {
    setModais(prev => ({ ...prev, [tipoModal]: true }));

    if (dados) {
      setDadosModais(prev => ({
        ...prev,
        ...dados
      }));
    }
  };

  const fecharModal = (tipoModal: keyof typeof modais) => {
    setModais(prev => ({ ...prev, [tipoModal]: false }));

    if (tipoModal === 'edicao') {
      setDadosModais(prev => ({
        ...prev,
        originadorParaEdicao: null,
        dadosEdicao: {
          razao_social: '',
          nome_fantasia: '',
          cnpj: '',
          ativo: true
        }
      }));
    } else if (tipoModal === 'cedentes') {
      setDadosModais(prev => ({ ...prev, originadorCedentes: null }));
    } else if (tipoModal === 'adicionarCedente') {
      setDadosModais(prev => ({
        ...prev,
        novoCedente: {
          cedente_id: 0,
          id_header_cnab: '',
          id_cnab: '',
          modelo_termo: 1,
          ativo: true
        }
      }));
    } else if (tipoModal === 'novoOriginador') {
      setDadosModais(prev => ({
        ...prev,
        novoOriginador: {
          razao_social: '',
          nome_fantasia: '',
          cnpj: '',
          ativo: true
        },
        cedentesNovoOriginador: []
      }));
    } else if (tipoModal === 'edicaoCedente') {
      setDadosModais(prev => ({
        ...prev,
        cedenteParaEdicao: null,
        dadosEdicaoCedente: {
          nome: '',
          cnpj: '',
          id_header_cnab: '',
          id_cnab: '',
          modelo_termo: 1,
          ativo: true
        }
      }));
    }
  };

  const abrirModalEdicao = (originador: Originador) => {
    abrirModal('edicao', {
      originadorParaEdicao: originador,
      dadosEdicao: {
        razao_social: originador.razao_social,
        nome_fantasia: originador.nome_fantasia,
        cnpj: originador.cnpj,
        ativo: originador.ativo
      }
    });
  };

  const abrirModalCedentes = (originador: Originador) => {
    abrirModal('cedentes', { originadorCedentes: originador });
    setAlteracoesPendentes(false);
  };


  const abrirModalAdicionarCedente = () => {
    abrirModal('adicionarCedente');
  };

  const abrirModalNovoOriginador = () => {
    abrirModal('novoOriginador');
  };

  const salvarEdicao = () => {
    if (dadosModais.originadorParaEdicao) {
      console.log('Salvando edição:', dadosModais.dadosEdicao);
      fecharModal('edicao');
    }
  };


  const salvarNovoCedente = () => {
    if (dadosModais.originadorCedentes && dadosModais.novoCedente.cedente_id !== 0) {
      const cedenteSelecionado = cedentesDisponiveis.find(c => c.id === dadosModais.novoCedente.cedente_id);
      if (cedenteSelecionado) {
        const novoId = Math.max(...dadosModais.originadorCedentes.cedentes.map(c => c.id)) + 1;
        const cedenteCompleto = {
          id: novoId,
          nome: cedenteSelecionado.nome,
          cnpj: cedenteSelecionado.cnpj,
          ativo: dadosModais.novoCedente.ativo,
          id_header_cnab: dadosModais.novoCedente.id_header_cnab,
          id_cnab: dadosModais.novoCedente.id_cnab,
          modelo_termo: dadosModais.novoCedente.modelo_termo
        };
        console.log('Adicionando novo cedente:', cedenteCompleto);
        fecharModal('adicionarCedente');
      }
    }
  };

  const toggleStatusCedente = (cedenteId: number) => {
    if (dadosModais.originadorCedentes) {
      const cedentesAtualizados = dadosModais.originadorCedentes.cedentes.map(cedente =>
        cedente.id === cedenteId ? { ...cedente, ativo: !cedente.ativo } : cedente
      );

      setDadosModais(prev => ({
        ...prev,
        originadorCedentes: {
          ...prev.originadorCedentes!,
          cedentes: cedentesAtualizados
        }
      }));

      setAlteracoesPendentes(true);
    }
  };

  const salvarAlteracoesCedentes = () => {
    if (dadosModais.originadorCedentes) {
      console.log('Salvando alterações dos cedentes:', dadosModais.originadorCedentes.cedentes);
      // Aqui você pode implementar a lógica para salvar no backend
      setAlteracoesPendentes(false); // Reset das alterações pendentes
      fecharModal('cedentes');
    }
  };

  const fecharModalComConfirmacao = (tipoModal: keyof typeof modais) => {
    if (tipoModal === 'cedentes' && alteracoesPendentes) {
      // Verificar se o usuário tem permissão para fazer alterações
      // Se não tiver permissão, pode sair sem confirmação
      const temPermissao = localStorage.getItem('userPermissions');
      if (temPermissao) {
        try {
          const permissions = JSON.parse(temPermissao);
          if (permissions.includes('REGISTER_ORIGINATOR')) {
            // Tem permissão, mostrar confirmação
            setModalParaFechar(tipoModal);
            setModais(prev => ({ ...prev, confirmacaoSaida: true }));
          } else {
            // Não tem permissão, pode sair sem confirmação
            fecharModal(tipoModal);
          }
        } catch (error) {
          // Erro ao parsear permissões, permitir sair
          fecharModal(tipoModal);
        }
      } else {
        // Sem permissões salvas, permitir sair
        fecharModal(tipoModal);
      }
    } else {
      fecharModal(tipoModal);
    }
  };

  const confirmarSaida = () => {
    if (modalParaFechar === 'cedentes') {
      salvarAlteracoesCedentes();
    }
    setModais(prev => ({ ...prev, confirmacaoSaida: false }));
    setModalParaFechar(null);
  };

  const descartarAlteracoes = () => {
    if (modalParaFechar === 'cedentes') {
      setAlteracoesPendentes(false);
      fecharModal(modalParaFechar);
    }
    setModais(prev => ({ ...prev, confirmacaoSaida: false }));
    setModalParaFechar(null);
  };

  const salvarNovoOriginador = () => {
    // Marcar que tentou salvar
    setValidacaoErro(prev => ({ ...prev, tentouSalvar: true }));

    // Validação dos campos obrigatórios
    const originadorValido = validarOriginador();
    const cedentesValidos = validarCedentes();

    if (originadorValido && cedentesValidos) {
      console.log('Criando novo originador:', {
        originador: dadosModais.novoOriginador,
        cedentes: dadosModais.cedentesNovoOriginador
      });
      fecharModal('novoOriginador');
    } else {
      // Definir erros de validação visual
      const novosErros = {
        originador: {
          razao_social: dadosModais.novoOriginador.razao_social.trim() === '',
          nome_fantasia: dadosModais.novoOriginador.nome_fantasia.trim() === '',
          cnpj: dadosModais.novoOriginador.cnpj.trim() === ''
        },
        cedentes: dadosModais.cedentesNovoOriginador.map(cedente => ({
          cedente_id: cedente.cedente_id === 0
        })),
        tentouSalvar: true
      };

      setValidacaoErro(novosErros);
    }
  };

  const validarOriginador = () => {
    const { razao_social, nome_fantasia, cnpj } = dadosModais.novoOriginador;
    return razao_social.trim() !== '' && nome_fantasia.trim() !== '' && cnpj.trim() !== '';
  };

  const validarCedentes = () => {
    if (dadosModais.cedentesNovoOriginador.length === 0) {
      return false; // Pelo menos um cedente é obrigatório
    }

    return dadosModais.cedentesNovoOriginador.every(cedente =>
      cedente.cedente_id !== 0
    );
  };


  const adicionarCedenteNovoOriginador = () => {
    setDadosModais(prev => ({
      ...prev,
      cedentesNovoOriginador: [
        ...prev.cedentesNovoOriginador,
        {
          cedente_id: 0
        }
      ]
    }));
  };

  const removerCedenteNovoOriginador = (index: number) => {
    setDadosModais(prev => ({
      ...prev,
      cedentesNovoOriginador: prev.cedentesNovoOriginador.filter((_, i) => i !== index)
    }));
  };

  const atualizarCedenteNovoOriginador = (index: number, field: string, value: string | number) => {
    setDadosModais(prev => ({
      ...prev,
      cedentesNovoOriginador: prev.cedentesNovoOriginador.map((cedente, i) =>
        i === index ? { ...cedente, [field]: value } : cedente
      )
    }));
  };

  const isCedenteSelecionado = (cedenteId: number, currentIndex: number) => {
    return dadosModais.cedentesNovoOriginador.some((cedente, index) =>
      index !== currentIndex && cedente.cedente_id === cedenteId
    );
  };

  const isCedenteJaAdicionado = (cedenteId: number) => {
    if (!dadosModais.originadorCedentes) return false;
    return dadosModais.originadorCedentes.cedentes.some(cedente => cedente.id === cedenteId);
  };

  const handleInputChange = (tipo: 'edicao' | 'cedente' | 'novoOriginador', field: string, value: string | boolean) => {
    const key = tipo === 'novoOriginador' ? 'novoOriginador' : `dados${tipo.charAt(0).toUpperCase() + tipo.slice(1)}`;
    setDadosModais(prev => ({
      ...prev,
      [key]: {
        ...prev[key as keyof typeof prev],
        [field]: value
      }
    }));
  };

  const ModelosTermo = [
    { id: 1, nome: 'Click' },
    { id: 2, nome: 'D4Sign' },
    { id: 3, nome: 'Não aplicável' }
  ];

  return (
    <ErrorBoundary>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <h5 className="card-title">Cadastro de Originadores</h5>
        <PermissionGate required="REGISTER_ORIGINATOR">
          <button
            className="fn-button fn-button--emphasized"
            onClick={abrirModalNovoOriginador}
          >
            <div className="fn-button__text">
              <FontAwesomeIcon icon={faPlus} style={{ marginRight: '8px' }} />
              Novo Originador
            </div>
          </button>
        </PermissionGate>
      </div>
      <Table>
        <thead>
          <tr>
            <th>CNPJ</th>
            <th>Razão Social</th>
            <th>Nome Fantasia</th>
            <th>Situação</th>
            <th>Cedentes</th>
            {isAdmin && <th>Editar</th>}
          </tr>
        </thead>
        <tbody>
          {mockData.map((item, index) => (
            <tr key={index}>
              <td>{item.cnpj}</td>
              <td>{item.razao_social}</td>
              <td>{item.nome_fantasia}</td>
              <td>
                <span className={`badge ${item.ativo ? 'ativo' : 'inativo'}`}>
                  {item.ativo ? 'Ativo' : 'Inativo'}
                </span>
              </td>
              <td>
                <button
                  className="fn-button fn-button--icon fn-button--secondary"
                  onClick={() => abrirModalCedentes(item)}
                  title="Ver cedentes"
                >
                  <div className="fn-button__text">
                    <FontAwesomeIcon icon={faEye} />
                  </div>
                </button>
              </td>
              <td>
                <PermissionGate required="UPDATE_ORIGINATOR">
                  <button
                    className="fn-button fn-button--icon fn-button--secondary"
                    onClick={() => abrirModalEdicao(item)}
                    title="Editar originador"
                  >
                    <div className="fn-button__text">
                      <FontAwesomeIcon icon={faEdit} />
                    </div>
                  </button>
                </PermissionGate>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {modais.cedentes && dadosModais.originadorCedentes && (
        <div className="modal-overlay" onClick={() => fecharModalComConfirmacao('cedentes')}>
          <div className="modal-content modal-content--large" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">
                Cedentes - {dadosModais.originadorCedentes.nome_fantasia}
              </h3>
              <button
                className="modal-close"
                onClick={() => fecharModalComConfirmacao('cedentes')}
                title="Fechar"
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
            <div className="modal-body">
              <Table>
                <thead>
                  <tr>
                    <th>CNPJ</th>
                    <th>Nome</th>
                    <th>Status</th>
                    <th>ID Header CNAB</th>
                    <th>Modelo termo</th>
                    {isAdmin && <th>Ativo</th>}
                  </tr>
                </thead>
                <tbody>
                  {dadosModais.originadorCedentes.cedentes.map((cedente) => (
                    <tr key={cedente.id}>
                      <td>{cedente.cnpj}</td>
                      <td>{cedente.nome}</td>
                      <td>
                        <span className={`badge ${cedente.ativo ? 'ativo' : 'inativo'}`}>
                          {cedente.ativo ? 'Ativo' : 'Inativo'}
                        </span>
                      </td>
                      <td>{cedente.id_header_cnab}</td>
                      <td>{ModelosTermo.find(modelo => modelo.id === cedente.modelo_termo)?.nome}</td>
                      {isAdmin && (
                        <td>
                          <label className="checkbox-label">
                            <input
                              type="checkbox"
                              checked={cedente.ativo}
                              onChange={() => toggleStatusCedente(cedente.id)}
                              className="checkbox-input"
                            />
                            <span className="checkbox-text">Ativo</span>
                          </label>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <div className="modal-footer">
              <PermissionGate required="REGISTER_ORIGINATOR">
                <button
                  className="fn-button fn-button--emphasized"
                  onClick={abrirModalAdicionarCedente}
                >
                  <div className="fn-button__text">
                    <FontAwesomeIcon icon={faPlus} style={{ marginRight: '8px' }} />
                    Adicionar Cedente
                  </div>
                </button>

                <button
                  className="fn-button fn-button--emphasized"
                  onClick={salvarAlteracoesCedentes}
                >
                  <div className="fn-button__text">
                    <FontAwesomeIcon icon={faSave} style={{ marginRight: '8px' }} />
                    Salvar
                  </div>
                </button>
              </PermissionGate>
              <button
                className="fn-button fn-button--secondary"
                onClick={() => fecharModalComConfirmacao('cedentes')}
              >
                <div className="fn-button__text">Fechar</div>
              </button>
            </div>
          </div>
        </div>
      )}


      {modais.adicionarCedente && (
        <div className="modal-overlay" onClick={() => fecharModal('adicionarCedente')}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">Adicionar Novo Cedente</h3>
              <button
                className="modal-close"
                onClick={() => fecharModal('adicionarCedente')}
                title="Fechar"
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label className="form-label form-label--required">Cedente</label>
                <select
                  className="form-input"
                  value={dadosModais.novoCedente.cedente_id}
                  onChange={(e) => setDadosModais(prev => ({
                    ...prev,
                    novoCedente: { ...prev.novoCedente, cedente_id: parseInt(e.target.value) }
                  }))}
                  required
                >
                  <option value={0}>Selecione um cedente</option>
                  {cedentesDisponiveis.map((cedente) => (
                    <option
                      key={cedente.id}
                      value={cedente.id}
                      disabled={isCedenteJaAdicionado(cedente.id)}
                    >
                      {cedente.nome} - {cedente.cnpj}
                      {isCedenteJaAdicionado(cedente.id) ? ' (Já adicionado)' : ''}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="fn-button fn-button--secondary"
                onClick={() => fecharModal('adicionarCedente')}
              >
                <div className="fn-button__text">Cancelar</div>
              </button>
              <button
                className="fn-button fn-button--emphasized"
                onClick={salvarNovoCedente}
              >
                <div className="fn-button__text">
                  <FontAwesomeIcon icon={faSave} style={{ marginRight: '8px' }} />
                  Salvar
                </div>
              </button>
            </div>
          </div>
        </div>
      )}

      {modais.edicao && dadosModais.originadorParaEdicao && (
        <div className="modal-overlay" onClick={() => fecharModal('edicao')}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">
                Editar Originador - {dadosModais.originadorParaEdicao.nome_fantasia}
              </h3>
              <button
                className="modal-close"
                onClick={() => fecharModal('edicao')}
                title="Fechar"
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label className="form-label">Razão Social</label>
                <input
                  type="text"
                  className="form-input"
                  value={dadosModais.dadosEdicao.razao_social}
                  onChange={(e) => handleInputChange('edicao', 'razao_social', e.target.value)}
                  placeholder="Digite a razão social"
                />
              </div>
              <div className="form-group">
                <label className="form-label">Nome Fantasia</label>
                <input
                  type="text"
                  className="form-input"
                  value={dadosModais.dadosEdicao.nome_fantasia}
                  onChange={(e) => handleInputChange('edicao', 'nome_fantasia', e.target.value)}
                  placeholder="Digite o nome fantasia"
                />
              </div>
              <div className="form-group">
                <label className="form-label">CNPJ</label>
                <input
                  type="text"
                  className="form-input"
                  value={dadosModais.dadosEdicao.cnpj}
                  onChange={(e) => handleInputChange('edicao', 'cnpj', e.target.value)}
                  placeholder="00.000.000/0000-00"
                />
              </div>
              <div className="form-group">
                <label className="form-label">Situação</label>
                <div className="radio-group">
                  <label className="radio-label">
                    <input
                      type="radio"
                      name="Situção"
                      value="ativo"
                      checked={dadosModais.dadosEdicao.ativo === true}
                      onChange={() => handleInputChange('edicao', 'ativo', true)}
                      className="radio-input"
                    />
                    <span className="radio-text">Ativo</span>
                  </label>
                  <label className="radio-label">
                    <input
                      type="radio"
                      name="Situção"
                      value="inativo"
                      checked={dadosModais.dadosEdicao.ativo === false}
                      onChange={() => handleInputChange('edicao', 'ativo', false)}
                      className="radio-input"
                    />
                    <span className="radio-text">Inativo</span>
                  </label>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="fn-button fn-button--secondary"
                onClick={() => fecharModal('edicao')}
              >
                <div className="fn-button__text">Cancelar</div>
              </button>
              <button
                className="fn-button fn-button--emphasized"
                onClick={salvarEdicao}
              >
                <div className="fn-button__text">
                  <FontAwesomeIcon icon={faSave} style={{ marginRight: '8px' }} />
                  Salvar
                </div>
              </button>
            </div>
          </div>
        </div>
      )}

      {modais.novoOriginador && (
        <div className="modal-overlay" onClick={() => fecharModal('novoOriginador')}>
          <div className="modal-content modal-content--large" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">Novo Originador</h3>
              <button
                className="modal-close"
                onClick={() => fecharModal('novoOriginador')}
                title="Fechar"
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              {/* Seção 1: Dados do Originador */}
              <div className="form-section">
                <h4 className="section-title">Dados do Originador</h4>
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label form-label--required">Razão Social</label>
                    <input
                      type="text"
                      className={`form-input ${validacaoErro.tentouSalvar && validacaoErro.originador.razao_social ? 'form-input--error' : ''}`}
                      value={dadosModais.novoOriginador.razao_social}
                      onChange={(e) => handleInputChange('novoOriginador', 'razao_social', e.target.value)}
                      placeholder="Digite a razão social"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label form-label--required">Nome Fantasia</label>
                    <input
                      type="text"
                      className={`form-input ${validacaoErro.tentouSalvar && validacaoErro.originador.nome_fantasia ? 'form-input--error' : ''}`}
                      value={dadosModais.novoOriginador.nome_fantasia}
                      onChange={(e) => handleInputChange('novoOriginador', 'nome_fantasia', e.target.value)}
                      placeholder="Digite o nome fantasia"
                      required
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label form-label--required">CNPJ</label>
                    <input
                      type="text"
                      className={`form-input ${validacaoErro.tentouSalvar && validacaoErro.originador.cnpj ? 'form-input--error' : ''}`}
                      value={dadosModais.novoOriginador.cnpj}
                      onChange={(e) => handleInputChange('novoOriginador', 'cnpj', e.target.value)}
                      placeholder="00.000.000/0000-00"
                      required
                    />
                  </div>
                  <div className="form-group">
                  </div>
                </div>
              </div>

              {/* Seção 2: Cedentes */}
              <div className="form-section">
                <div className="section-header">
                  <h4 className="section-title">Cedentes</h4>
                  <button
                    type="button"
                    className="fn-button fn-button--secondary fn-button--icon"
                    onClick={adicionarCedenteNovoOriginador}
                    title="Adicionar cedente"
                  >
                    <div className="fn-button__text">
                      <FontAwesomeIcon icon={faPlus} />
                    </div>
                  </button>
                </div>
                {dadosModais.cedentesNovoOriginador.map((cedente, index) => (
                  <div key={index} className="fund-form-row">
                    <div className="form-row">
                      <div className="form-group">
                        <label className="form-label form-label--required">Cedente</label>
                        <select
                          className={`form-input ${validacaoErro.tentouSalvar && validacaoErro.cedentes[index]?.cedente_id ? 'form-input--error' : ''}`}
                          value={cedente.cedente_id}
                          onChange={(e) => atualizarCedenteNovoOriginador(index, 'cedente_id', parseInt(e.target.value))}
                          required
                        >
                          <option value={0}>Selecione um cedente</option>
                          {cedentesDisponiveis.map((cedenteDisponivel) => (
                            <option
                              key={cedenteDisponivel.id}
                              value={cedenteDisponivel.id}
                              disabled={isCedenteSelecionado(cedenteDisponivel.id, index)}
                            >
                              {cedenteDisponivel.nome} - {cedenteDisponivel.cnpj}
                              {isCedenteSelecionado(cedenteDisponivel.id, index) ? ' (Já selecionado)' : ''}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="form-group">
                        <button
                          type="button"
                          className="fn-button fn-button--secondary fn-button--icon"
                          onClick={() => removerCedenteNovoOriginador(index)}
                          title="Remover cedente"
                        >
                          <div className="fn-button__text">
                            <FontAwesomeIcon icon={faTimes} />
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="fn-button fn-button--secondary"
                onClick={() => fecharModal('novoOriginador')}
              >
                <div className="fn-button__text">Cancelar</div>
              </button>
              <button
                className="fn-button fn-button--emphasized"
                onClick={salvarNovoOriginador}
              >
                <div className="fn-button__text">
                  <FontAwesomeIcon icon={faSave} style={{ marginRight: '8px' }} />
                  Salvar
                </div>
              </button>
            </div>
          </div>
        </div>
      )}

      <PermissionGate required="REGISTER_ORIGINATOR"> 
      {modais.confirmacaoSaida && (
        <div className="modal-overlay" onClick={() => setModais(prev => ({ ...prev, confirmacaoSaida: false }))}>
          <div className="modal-content modal-content--small" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">Alterações não salvas</h3>
              <button
                className="modal-close"
                onClick={() => setModais(prev => ({ ...prev, confirmacaoSaida: false }))}
                title="Fechar"
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
            <div className="modal-body">
              <p>Você tem alterações não salvas. O que deseja fazer?</p>
            </div>
            <div className="modal-footer">
              <button
                className="fn-button fn-button--secondary"
                onClick={descartarAlteracoes}
              >
                <div className="fn-button__text">
                  <FontAwesomeIcon icon={faXmark} style={{ marginRight: '8px' }} />
                  Descartar alterações
                </div>
              </button>
              <button
                className="fn-button fn-button--emphasized"
                onClick={confirmarSaida}
              >
                <div className="fn-button__text">
                  <FontAwesomeIcon icon={faCheck} style={{ marginRight: '8px' }} />
                  Salvar e sair
                </div>
              </button>
            </div>
          </div>
        </div>
      )}
      </PermissionGate>
    </ErrorBoundary>
  );
};

export default CadastroOriginador;